import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </C>
  );
};

const lineVariants = {
  hidden: { y: "110%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: d } }),
};

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0.15, inView = false }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span className={`block ${lineClass}`} variants={lineVariants} custom={delay + i * 0.12}>
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Eyebrow = ({ children, tone = "dark", className = "" }) => (
  <span className={`eyebrow inline-flex items-center gap-3 ${tone === "dark" ? "text-[#3f8a0f]" : "text-[#74DC26]"} ${className}`}>
    <span className="h-px w-8 bg-current" />
    {children}
  </span>
);

export const SectionHead = ({ eyebrow, title, intro, tone = "dark", className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    <Reveal>
      <Eyebrow tone={tone}>{eyebrow}</Eyebrow>
    </Reveal>
    <h2 className={`font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-medium leading-[1.05] tracking-tight ${tone === "dark" ? "text-[#082619]" : "text-[#F9F8F3]"}`}>
      <MaskLines lines={Array.isArray(title) ? title : [title]} inView />
    </h2>
    {intro && (
      <Reveal delay={0.15}>
        <p className={`mt-6 text-base md:text-lg leading-relaxed ${tone === "dark" ? "text-[#4C6053]" : "text-[#B4C7BA]"}`}>{intro}</p>
      </Reveal>
    )}
  </div>
);
